export enum PublicationStatusEnum {
  Active = 'Active',
  InActive = 'InActive',
  Draft = 'Draft',
  Internal = 'Internal',
}
